import React, { useEffect, useState } from "react";
import DTOSwapShiftModalAR from "./DTOSwapShiftModalAR";
import SwapShiftModalARPresenter from "./SwapShiftModalARPresenter";

import { useTranslation } from "react-i18next";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
}

const SwapShiftModalARController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const { t } = useTranslation();

  return (
    <div>
      <DTOSwapShiftModalAR />

      <SwapShiftModalARPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
    </div>
  );
};

export default SwapShiftModalARController;
